import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import KollabDocumentViewer from './KollabDocumentViewer';
import type {
  KollabDocumentViewerProps,
  KollabDocumentViewerAPI,
  KollabDocumentViewerHandle,
} from './types';

declare global {
  interface Window {
    mountKollabDocumentViewer: (
      containerId: string,
      props: KollabDocumentViewerProps,
    ) => KollabDocumentViewerHandle;
  }
}

window.mountKollabDocumentViewer = function mountKollabDocumentViewer(
  containerId: string,
  props: KollabDocumentViewerProps,
): KollabDocumentViewerHandle {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('KollabDocumentViewer: container not found:', containerId);
    return {
      type: 'document',
      unmount: () => {},
      get api() { return null; },
    };
  }

  const apiRef = createRef<KollabDocumentViewerAPI>();
  const root = createRoot(container);
  root.render(React.createElement(KollabDocumentViewer, { ...props, ref: apiRef }));

  return {
    type: 'document',
    unmount: () => root.unmount(),
    get api() { return apiRef.current; },
  };
};

export type {
  KollabDocumentViewerProps,
  KollabDocumentViewerAPI,
  KollabDocumentViewerHandle,
};
